import Keycloak from 'keycloak-js';

/**
 * Singleton Keycloak instance.
 * Initialized once in AuthContext. Exported here so api/client.ts
 * can inject the Bearer token without going through React context.
 */
const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL || 'http://localhost:8180',
  realm: import.meta.env.VITE_KEYCLOAK_REALM || 'authmatech',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'authmatech-dashboard',
});

export default keycloak;
